<eds-panel
  [enableHover]="false"
  [hasBorderRadius]="false"
  [hasBorders]="true"
  [hasPadding]="true"
  [hasShadows]="false"
  theme="white"
>
  <div edsGrid>
    <div edsRow>
      <div edsCol>
        <eds-proximal placement="DailyPricesProximalTop"></eds-proximal>
        <eds-section-header
          [title]="'products.price-share-prices' | translate: fundId"
          [level]="3"
          [isLight]="true"
          theme="primary"
          size="h6"
          [asOfLabel]="'products.as-at' | translate: fundId"
          [asOfDate]="navData.navAsOfDate"
          [updateFrequency]="'products.updated-daily' | translate: fundId"
          caveatPlacement="Price:DailyFundPricesPriceDistribution"
          edsSpacing="md"
        ></eds-section-header>
      </div>
    </div>

    <div>
      <div edsCssCols edsSubGrid="layout-1" colGap="xxl">
        <ng-container *ngIf="infoItems[1].length == 0">
          <eds-info-item
            *ngFor="let item of infoItems[0]"
            [info]="item"
            edsSpacing="sm"
          >
          </eds-info-item>
        </ng-container>
        <ng-container *ngIf="infoItems[1].length > 0">
          <div>
            <eds-info-item
              *ngFor="let item of infoItems[0]"
              [info]="item"
              edsSpacing="xs"
            >
            </eds-info-item>
          </div>
          <div>
            <eds-info-item
              *ngFor="let item of infoItems[1]"
              [info]="item"
              edsSpacing="xs"
            >
            </eds-info-item>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</eds-panel>
